import * as localeData from 'locales';
import React, { useMemo, useState } from 'react';
import { IntlProvider, MessageDescriptor, useIntl } from 'react-intl';
import { LocaleContext } from 'designSystem/context';

import { LocaleProviderProps } from './LocaleProvider.types';

const locales = localeData.default;

const LocaleContextAdapter = ({
  children,
  locale,
  updateLocale,
}: {
  children: React.ReactNode;
  locale: string;
  updateLocale: (locale: string) => void;
}) => {
  const intl = useIntl();
  const context = useMemo(
    () => ({
      formatMessage: (message: MessageDescriptor) => String(intl.formatMessage(message)),
      locale,
      updateLocale,
    }),
    [intl, locale, updateLocale],
  );

  return <LocaleContext.Provider value={context}>{children}</LocaleContext.Provider>;
};

export const LocaleProvider = (props: LocaleProviderProps) => {
  const [locale, setLocale] = useState(props.locale);
  const messages = locales[locale];

  const updateLocale = (newLocale: string) => {
    setLocale(newLocale);
  };

  return (
    <IntlProvider locale={locale} messages={messages}>
      <LocaleContextAdapter updateLocale={updateLocale} locale={locale}>
        {props.children}
      </LocaleContextAdapter>
    </IntlProvider>
  );
};
